// extracted by mini-css-extract-plugin
export var actionLink = "PartnerOverviewPage-module__actionLink___nO0XX";
export var adminAvatar = "PartnerOverviewPage-module__adminAvatar___INggH";
export var administratorDetails = "PartnerOverviewPage-module__administratorDetails___0tcPj";
export var administratorList = "PartnerOverviewPage-module__administratorList___0-o5c";
export var administratorName = "PartnerOverviewPage-module__administratorName___-iLme";
export var avatar = "PartnerOverviewPage-module__avatar___kokPc";
export var avatarList = "PartnerOverviewPage-module__avatarList___f3hMu";
export var card = "PartnerOverviewPage-module__card___HKH+h";
export var divider = "PartnerOverviewPage-module__divider___WqBca";
export var empty = "PartnerOverviewPage-module__empty___X8l-j";
export var error = "PartnerOverviewPage-module__error___6Nkxf";
export var layout = "PartnerOverviewPage-module__layout___qB+H0";
export var mainColumn = "PartnerOverviewPage-module__mainColumn___iTKR8";
export var peopleCard = "PartnerOverviewPage-module__peopleCard___2s2Fl";
export var peopleFooter = "PartnerOverviewPage-module__peopleFooter___UF8Ia";
export var peopleHeader = "PartnerOverviewPage-module__peopleHeader___o3qGe";
export var rightColumn = "PartnerOverviewPage-module__rightColumn___2Vbur";
export var screenReaderOnly = "PartnerOverviewPage-module__screenReaderOnly___5QNaX";